<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <app-season-detail
      [season]="season"
      [mode]="mode"
      [defaultLanguage]="defaultLanguage"
      [additionalLanguages]="additionalLanguages"
      [isModal]="true"
      (savedSeason)="onSavedSeason($event)"
      (canceledSeason)="onCanceledSeason()"
    ></app-season-detail>
  </div>
</div>
